import React from 'react';
import cx from 'classnames';
import { withFormik } from 'formik';
import * as Yup from 'yup';
import styles from './DailyAffirmationsForm.module.css';

const DailyAffirmationsForm = props => {
  const {
    values,
    touched,
    errors,
    isSubmitting,
    handleChange,
    handleBlur,
    handleSubmit
  } = props;

  return (
    <form onSubmit={handleSubmit} className={styles.form}>
      <div className={styles.row}>
        <div
          className={cx(styles.formGroup, {
            [styles.formGroupError]: errors.name && touched.name
          })}
        >
          <input
            id="name"
            type="text"
            name="name"
            placeholder="Your Name"
            className={styles.formControl}
            value={values.name}
            onChange={handleChange}
            onBlur={handleBlur}
            disabled={isSubmitting}
          />
          {errors.name && touched.name && (
            <label className={styles.validationError}>{errors.name}</label>
          )}
        </div>
        <div
          className={cx(styles.formGroup, {
            [styles.formGroupError]: errors.email && touched.email
          })}
        >
          <input
            id="email"
            type="text"
            name="email"
            placeholder="Your Email Address"
            className={styles.formControl}
            value={values.email}
            onChange={handleChange}
            onBlur={handleBlur}
            disabled={isSubmitting}
          />
          {errors.email && touched.email && (
            <label className={styles.validationError}>{errors.email}</label>
          )}
        </div>
      </div>
      <div className={styles.btnContainer}>
        <button className={styles.btn} type="submit" disabled={isSubmitting}>
          Sign Up
        </button>
      </div>
    </form>
  );
};

export default withFormik({
  mapPropsToValues: ({ values: { name = '', email = '' } }) => ({
    name,
    email
  }),
  validationSchema: Yup.object().shape({
    name: Yup.string().required('Please enter your name.'),
    email: Yup.string()
      .required('Please enter your email address.')
      .email('Please enter a valid email address.')
  }),
  handleSubmit: (values, { resetForm, setSubmitting, props }) => {
    const { onSubmitHandler } = props;
    onSubmitHandler(values, setSubmitting);
  },
  enableReinitialize: true
})(DailyAffirmationsForm);
